import { AnalyticsBrowser, type MiddlewareFunction } from '@segment/analytics-next'

const createSegmentClient = () => {
    const analytics = new AnalyticsBrowser()
    let segmentLoaded = false
    let segmentConsentRevoked = false

    const consentMiddleware: MiddlewareFunction = ({ payload, next }) => {
        next(segmentConsentRevoked ? null : payload)
    }

    analytics.addSourceMiddleware(consentMiddleware)

    const loadSegment = (writeKey: string) => {
        if (!writeKey || segmentLoaded) {
            return
        }

        analytics.load({ writeKey })
        segmentLoaded = true
    }

    const setSegmentConsent = (hasConsent: boolean) => {
        if (!segmentLoaded) {
            return
        }

        if (!hasConsent && !segmentConsentRevoked) {
            analytics.reset()
        }

        segmentConsentRevoked = !hasConsent
    }

    return { analytics, loadSegment, setSegmentConsent }
}

const segmentClient = createSegmentClient()

export const { analytics, loadSegment, setSegmentConsent } = segmentClient
